import './src/styles/global.css'
import "@fontsource/montserrat/800.css"
import "@fontsource/montserrat"
import "typeface-nunito-sans";
import * as React from 'react'
import { Analytics } from '@vercel/analytics/react'
import { trackPageView } from './src/utils/logger'

export const wrapRootElement = ({ element }) => {
  return (
    <>
      {element}
      <Analytics />
    </>
  )
}

export const onInitialClientRender = () => {
  trackPageView()
}

export const onRouteUpdate = () => {
  trackPageView()
}
